import { Printer } from "lucide-react"
import { useSearchParams } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { todayInLosAngeles } from "@/lib/format"

export function useKitchenDate(): [string, (next: string) => void] {
  const [params, setParams] = useSearchParams()
  const date = params.get("date") || todayInLosAngeles()
  function setDate(next: string) {
    const copy = new URLSearchParams(params)
    copy.set("date", next)
    setParams(copy, { replace: true })
  }
  return [date, setDate]
}

export function DateToolbar({
  date,
  onChange,
  onPrint,
}: {
  date: string
  onChange: (next: string) => void
  onPrint?: () => void
}) {
  return (
    <div className="flex items-center gap-2">
      <Input className="w-40" onChange={(e) => onChange(e.target.value)} type="date" value={date} />
      {onPrint ? (
        <Button onClick={onPrint} size="sm" type="button" variant="outline">
          <Printer className="size-4" />
          Print
        </Button>
      ) : null}
    </div>
  )
}
